import "../../styles/global.css";
import React, { useState, useEffect } from "react";
import { fetchDemoQuestionAverage, fetchAllDemoSubmissionDates } from "../../api/overviewApi";
import TrendChart from "./TrendChart";

const Trend = () => {

    const [allDates, setAllDates] = useState([]);
    const [trendData, setTrendData] = useState([]);

    function generateDateRanges(minDate, maxDate, numBins = 20) {
        const step = (maxDate - minDate) / numBins;
        return Array.from({ length: numBins }, (_, i) => {
            const start = new Date(minDate + i * step).toISOString();
            const end = new Date(minDate + (i + 1) * step).toISOString();
            return [start, end];
        })
    }

    useEffect(() => {
        console.log("Fetching all demo submission dates for trend...");
        fetchAllDemoSubmissionDates()
            .then((data) => {
                const timestamps = data.dates.map((d) => new Date(d).getTime());
                const minDate = Math.min(...timestamps);
                const maxDate = Math.max(...timestamps);
                setAllDates([minDate, maxDate]);
            })
            .catch((error) => {
                console.error("Error fetching all demo submission dates:", error);
            });
    }, []);

    useEffect(() => {
        if (allDates[0] && allDates[1]) {
            const [minDate, maxDate] = allDates;
            const dateRanges = generateDateRanges(minDate, maxDate);
            console.log("Generated Date Ranges:", dateRanges);

            Promise.all(
                dateRanges.map(([start, end]) =>
                    fetchDemoQuestionAverage(start, end).then((data) => ({
                            start,
                            end,
                            questions: data?.questions || [],
                        }))
                )
            ).then((timeSeriesData) => {
                const trends = {};

                timeSeriesData.forEach(({ start, end, questions }, index) => {
                    const timePoint = new Date((new Date(start).getTime() + new Date(end).getTime()) / 2).toISOString();

                    for (const q of questions) {
                        const construct = q.group_code;
                        const avg = parseFloat(q.avg_score);
                        if (!trends[construct]) trends[construct] = [];
                        trends[construct].push({ x: timePoint, y: avg });
                    }
                });

                setTrendData(trends);
            }).catch((error) => {
                console.error("Error fetching trend data:", error);
            });
        }
    }, [allDates]);

    return (
        <div className="wrapper">
            <h1 className="title">CLASS TRENDS OVER TIME</h1>
            <p>The three trend charts below show changes in each measure collected through the “Daily Reflection Opportunity” surveys. X-axis represent the submitted date of the surveys. You can click on each measure’s legend to mute or unmute it. Hover over a data point to see the exact score. Note that the frequency of data collection varies.</p>
            <TrendChart trendData={trendData} />
        </div>
    );
};

export default Trend;